import {Box, Stack, Paper, Typography, Divider, Button, styled, Collapse, useTheme} from '@mui/material';
import AppTextField from "@/components/AppTextField";
import RpIcon from "@/components/RpIcon";
import API from "@/constant/API";
import { clearTaskRule, setTaskRuleParams } from '@/redux/slices/user';
import {CARD_STRING_TYPE as CARD_TYPE, INPUT_THROTTLE_MS} from "@/constant/Constant";

import useSettings from "@/hook/useSettings";
import useToggle from "@/hook/useToggle";
import {getBillAddress, getCardBinList, getShippingAddress} from "@/redux/slices/card";
import {dispatch} from "@/redux/store";
import axiosInstance from "@/utils/axios";
import {getUrlParams} from "@/utils/utils";
import {debounce} from "es-toolkit";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import { useConfirm } from "material-ui-confirm";
import styles from "./index.module.less";

import {useBoolean, useRequest} from "ahooks";
import useWindowSize from "@/hook/useWindowSize";
import mobileClasses from "@/pages/cards/CardPurchaseSummary/mobile.module.css";
import {OutlinedBox} from "@/components/mui";
import RouteConstant from "@/constant/RouteConstant";

import {useNavigate, useLocation} from "react-router-dom";
import AppModal from "@/components/AppModal.tsx";

import { getApplyPreview } from '@/services/card'
import PaymentModal from './components/PaymentModal'
import {VerifyAction} from "@/constant/VerifyConstant";
import AppLoadingButton from "@/components/mui/LoadingButton";
import ShippingAddressDialog from "@/pages/user/components/ShippingAddressDialog";
import BillAddressDialog from "@/pages/user/components/BillAddressDialog";

import {tr} from "date-fns/locale";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import {confirm} from "@/components/ConfirmDialog.tsx";
import {enqueueSnackbar} from "notistack";
import OpenOrDownloadApp from "@/components/OpenOrDownloadApp";
import useSonicMigrateIntercept from "@/hook/useSonicMigrateIntercept";

const RRow = styled(Stack)(({theme}) => {
  return {
    backgroundColor: theme.palette.background.default,
    padding: '20px',
  }
})

export default function CardApplicationOrder() {
  const type = getUrlParams("cardType");
  const theme = useTheme()
  const {isMobile} = useWindowSize();
  const {settings} = useSettings();
  const {t} = useTranslation();
  const navigate = useNavigate()
  const location = useLocation()
  const confirm = useConfirm();
  const { showAppStoreModal, setShowAppStoreModal, interceptAction } = useSonicMigrateIntercept();
  const {user,homeInfo} = useSelector((state) => state.user);
  const {toggle: promoCodeOpen, onToggle: onTogglePromoOpen} = useToggle(false);
  const [promoCode, setPromoCode] = useState('');
  const [previewRes, setPreviewRes] = useState({})
  const [bin, setBin] = useState(null);
  const [paymentModalShow, paymentModalShowOperate] = useBoolean(null);

  const {cardBinList, billAddress, shippingAddress} = useSelector(state => state.card);

  const [payStep, setPayStep] = useState(true);

  const [shippingAddressOpen, shippingAddressOpenOperate] = useBoolean(false);
  const [billAddressOpen, billAddressOpenOperate] = useBoolean(false);

  const getApplyPreviewReq = useRequest(async (data) => {
    const res = await getApplyPreview(data)
    return res
  }, { manual: true })

  const needDeposit = useMemo(() => {
    if (parseFloat(bin?.price) > parseFloat(homeInfo?.assetUser.available)) {
      return true
    }
    return false
  }, [homeInfo, bin])

  useEffect(() => {
    _initData();
  }, []);

  useEffect(() => {
    if (cardBinList.length && type) {
      setBin(cardBinList.find(item => item.cardType == type));
    }
  }, [cardBinList]);
  useEffect(() => {
    if (bin) {
      _fetchPromoResult('');
    }
  }, [bin]);

  const _initData = () => {
    if (!cardBinList?.length) {
      dispatch(getCardBinList());
    }

    dispatch(getBillAddress());
    dispatch(getShippingAddress());
  }

  useEffect(() => {
    clearTaskRule()
    setTaskRuleParams(({
      action: VerifyAction.ORDER_CARD
    }))
  }, [])

  useEffect(() => {
    if (billAddress) {

    }
  }, [billAddress]);

  //支付
  const _handlePay = async () => {
    interceptAction();
  }

  const _onPromoCodeChange = (val) => {
    setPromoCode(val);
    _debounceFetchPromoResult(val);
  }

  const _fetchPromoResult = async function (promoCode: String) {
    if (!bin) return;

    const res = await axiosInstance.post(API.APPLY_CARD_COUPON_PREVIEW, {
      'cardBinSn': bin.sn,
      'couponCode': promoCode,
    });
    setPreviewRes({
      ...res,
      promoCode: promoCode,
    });
  };

  const _debounceFetchPromoResult = useCallback(debounce(_fetchPromoResult, INPUT_THROTTLE_MS), [bin]);

  const [paymentInfo, setPaymentInfo] = useState(null)

  // const paymentInfo = useMemo(() => {
  //   if (!getApplyPreviewReq.data) {
  //     return null;
  //   }
  //   return {
  //       ...getApplyPreviewReq.data,
  //       promoCode: promoCode,
  //     }
  // }, [getApplyPreviewReq?.data])

  useEffect(() => {
    if (paymentInfo) {
      paymentModalShowOperate.setTrue()
    }
  }, [paymentInfo]);

  const onBillAddressClose = () => {
    dispatch(getBillAddress());
    billAddressOpenOperate.setFalse()
  }

  const onShippingAddressClose = () => {
    dispatch(getShippingAddress());
    shippingAddressOpenOperate.setFalse()
  }

  return (
    <Stack direction="column" className={styles.root}>
      <SimpleHeader title={t('card_application_order')}/>
      <Box className={styles.content} sx={{paddingBottom: '78px'}}>
        <Stack direction="column" gap="8px">
          <Stack sx={theme => {
            return { backgroundColor: theme.palette.background.default };
          }} className={mobileClasses.root}>
            <Stack sx={{ height: "100%", overflowY: "auto" }}>
              <Box className={mobileClasses.topWrap}>
                <Stack direction="row" className={mobileClasses.card}>
                  {/* {bin && <img
                    src={`/images/cards/card-${bin?.cardType == CARD_TYPE.VIRTUAL ? "virtual" : "physical"}-${settings.theme}.png`}
                  />} */}
                  <img
                    style={{borderRadius:"8px"}}
                    src={`/images/sonic/sonic-card-mini.png`}
                  />
                  <Stack gap={'16px'}>
                    <Box>
                      <Typography fontSize={'16px'} fontWeight={500}>{`${bin?.cardType == CARD_TYPE.VIRTUAL ? t("virtual_card") : t("physical_card")}`}</Typography>
                      <Typography fontSize={'16px'} fontWeight={500}> x 1</Typography>
                    </Box>
                    <Typography fontSize={'16px'} fontWeight={500}>
                      {bin?.price ?? "--"} USD
                    </Typography>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          </Stack>
          <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '6px' }} />
          <RRow direction="column">
            <Stack direction="row" justifyContent="space-between" onClick={onTogglePromoOpen}>
              <Typography fontSize={'16px'} fontWeight={500}>{t("promo_code_optional")}</Typography>
              <RpIcon
                icon={promoCodeOpen ? "trangle-up" : "trangle-down"}
                clickable
                onClick={onTogglePromoOpen}
              />
            </Stack>
            <Collapse timeout={200} in={promoCodeOpen} orientation="vertical">
              <Stack className={styles["item-input"]}>
                <AppTextField
                  autoComplete="off"
                  clearable
                  onClear={() => {
                    setPromoCode('')
                  }}
                  labelText={t('promo_code')} value={promoCode}
                  onChange={(e) => _onPromoCodeChange(e.target.value)}/>
              </Stack>
            </Collapse>

            {/*{promoCodeOpen && (*/}
            {/*  */}
            {/*)}*/}
          </RRow>
          <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '6px' }} />
          <RRow direction="column" justifyContent="space-between" className={styles["item-title"]}
          >
            <Stack direction="row" justifyContent="space-between">
              <Typography fontSize={'16px'} fontWeight={500} sx={{marginBottom: '16px'}}> {t("billing_address")}</Typography>
              <Box onClick={() => {
                billAddressOpenOperate.setTrue()
                // navigate(RouteConstant.USER_BILL_ADDRESS)
              }}>
                <RpIcon
                  icon={billAddress && billAddress.sn ? 'edit' : 'plus'}
                  size={24}
                />
              </Box>
            </Stack>
            <Divider sx={{ borderColor: theme.palette.borderColor.divider, borderWidth: '0.5px' }}/>
            {billAddress?.country && <Stack direction="column" sx={{marginTop: '16px'}} justifyContent="space-between">
              <Typography>{billAddress?.country} {billAddress?.city}</Typography>
              <Typography>{billAddress?.line1}</Typography>
              <Typography>{billAddress?.line2}</Typography>
            </Stack>}
          </RRow>
          {bin && bin.cardType == CARD_TYPE.PHYSICAL && <>
            <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '6px' }} />
            <RRow direction="column" justifyContent="space-between" className={styles["item-title"]}
            >
              <Stack direction="row" justifyContent="space-between">
                <Typography fontSize={'16px'} fontWeight={500} sx={{marginBottom: '16px'}}> {t("shipping_to")}</Typography>
                <Box onClick={() => {
                  shippingAddressOpenOperate.setTrue()
                  // navigate(RouteConstant.USER_BILL_ADDRESS)
                }}>
                  <RpIcon icon={shippingAddress && shippingAddress.sn ? 'edit' : 'plus'} size={24}/>
                </Box>
              </Stack>
              <Divider sx={{ borderColor: theme.palette.borderColor.divider, borderWidth: '0.5px' }}/>
              {shippingAddress && <Stack direction="column" sx={{marginTop: '16px'}} justifyContent="space-between">
                <Typography>{shippingAddress?.receiveNation} {billAddress?.city}</Typography>
                <Typography>{shippingAddress?.receiveCity}</Typography>
                <Typography>{shippingAddress?.line2}</Typography>
              </Stack>}
            </RRow>
          </>}

          <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '6px' }} />
          <Stack className={mobileClasses.feeInfo}>
            <Box className={mobileClasses.title}>
              <Typography fontSize={'16px'} fontWeight={500} sx={{marginBottom: '16px'}}>
                {t("card_purchase_fee")}
              </Typography>
            </Box>
            <Divider sx={{ borderColor: theme.palette.borderColor.divider, borderWidth: '0.5px' }}/>
            <Box className={mobileClasses.list}>
              <Stack direction="row" justifyContent="space-between">
                <Typography color="text.secondary">{t("price")}</Typography>
                <Typography>{previewRes?.amount} USD</Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography color="text.secondary">{t("discount")}</Typography>
                <Typography>{previewRes?.discount} USD</Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography>{t("pay")}</Typography>
                <p className={'color-count-down'}>{previewRes?.bizAmount} USD</p>
              </Stack>
            </Box>
          </Stack>
        </Stack>

        <Box
          className={"fixed-button"}
        >
          <AppLoadingButton
            size={'large'}
            loading={getApplyPreviewReq.loading} variant="contained" fullWidth onClick={() => {
            _handlePay()
          }}>
            {t("pay")}
          </AppLoadingButton>
        </Box>

      </Box>
      {paymentInfo && <PaymentModal
        previewRes={previewRes}
        couponCode={promoCode}
        open={paymentModalShow} onClose={paymentModalShowOperate.setFalse}
        paymentInfo={paymentInfo}
        cardBinSn={bin}
      />}
      {/*<TwoFAModal open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse} />*/}
      <ShippingAddressDialog open={shippingAddressOpen} onClose={() => {


        onShippingAddressClose()
      }}/>
      <BillAddressDialog open={billAddressOpen} onClose={() => {

        onBillAddressClose()
      }}/>
      <OpenOrDownloadApp
        open={showAppStoreModal}
        onClose={() => setShowAppStoreModal(false)}
      />

    </Stack>
  );
}
